export default "__VITE_ASSET__DCQvRX$M__"